var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUserIconMultiColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6FA9FF",
  d: "M16.166 12.77A7.918 7.918 0 0 1 11.95 14a7.918 7.918 0 0 1-4.216-1.23 11.908 11.908 0 0 0-7.73 10.14A1 1 0 0 0 1 24h21.9a.997.997 0 0 0 .738-.326.997.997 0 0 0 .258-.764 11.908 11.908 0 0 0-7.73-10.14Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#154FA6",
  d: "M11.95 12a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
})));
export default SvgUserIconMultiColor;